import React from 'react';
import { Autocomplete, TextField, Chip, Box, Typography } from '@mui/material';
import { useProjects } from '../hooks/useProjects';
import { APPLAB_ACCENT } from '../constants';

export default function UppdragPicker({ value = [], onChange, label = 'Koppla till uppdrag (valfritt)' }) {
  const { projects, loading } = useProjects();

  const selectedOptions = value.map(v => projects.find(p => p.id === v.id) || v);

  function handleChange(_, selected) {
    onChange(selected.map(o => ({ id: o.id, projectNumber: o.projectNumber, name: o.name })));
  }

  return (
    <Autocomplete
      multiple
      disableCloseOnSelect
      options={projects}
      loading={loading}
      value={selectedOptions}
      onChange={handleChange}
      getOptionLabel={o => `${o.projectNumber || ''} · ${o.name || ''}`}
      isOptionEqualToValue={(o, v) => o.id === v.id}
      filterOptions={(opts, { inputValue }) => {
        const q = inputValue.toLowerCase();
        if (!q) return opts.slice(0, 10);
        return opts.filter(o =>
          (o.projectNumber || '').toLowerCase().includes(q) ||
          (o.name || '').toLowerCase().includes(q)
        ).slice(0, 10);
      }}
      renderTags={(selected, getTagProps) =>
        selected.map((o, i) => (
          <Chip
            key={o.id}
            label={o.projectNumber || o.name}
            size="small"
            {...getTagProps({ index: i })}
            sx={{
              bgcolor: APPLAB_ACCENT + '22', color: APPLAB_ACCENT,
              fontSize: '0.68rem', height: 22,
              '& .MuiChip-deleteIcon': { color: APPLAB_ACCENT + '88', '&:hover': { color: APPLAB_ACCENT } },
            }}
          />
        ))
      }
      renderOption={(props, option) => (
        <Box component="li" {...props} sx={{ py: '6px !important' }}>
          <Typography fontSize="0.82rem" sx={{ color: 'white' }}>
            <span style={{ color: APPLAB_ACCENT, fontWeight: 700 }}>{option.projectNumber}</span>
            {' · '}
            <span style={{ color: '#aaa' }}>{option.name}</span>
          </Typography>
        </Box>
      )}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          placeholder={selectedOptions.length > 0 ? '' : 'Sök på nummer eller namn…'}
          size="small"
          sx={{
            '& .MuiOutlinedInput-root': {
              color: 'white', bgcolor: 'rgba(255,255,255,0.04)',
              '& fieldset': { borderColor: 'rgba(255,255,255,0.12)' },
              '&:hover fieldset': { borderColor: APPLAB_ACCENT },
              '&.Mui-focused fieldset': { borderColor: APPLAB_ACCENT },
            },
            '& label': { color: '#888' },
            '& label.Mui-focused': { color: APPLAB_ACCENT },
          }}
        />
      )}
      componentsProps={{
        paper: { sx: { bgcolor: '#1e1e1e', color: 'white', border: '1px solid rgba(255,255,255,0.08)' } },
      }}
      noOptionsText={<span style={{ color: '#888', fontSize: '0.82rem' }}>Inga matchande uppdrag</span>}
      loadingText={<span style={{ color: '#888', fontSize: '0.82rem' }}>Laddar…</span>}
    />
  );
}
